// src/pages/ResetPassword.js
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../services/api';
import Card from '../components/Card';
import Button from '../components/Button';
import { toast } from 'react-toastify';

function ResetPassword() {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
        toast.error("Las contraseñas no coinciden");
        return;
    }
    
    try {
      await apiClient.post('/password-reset/confirm/', { 
        uid, token, new_password: password 
      });
      toast.success("¡Contraseña cambiada!");
      navigate('/login');
    } catch (error) {
      toast.error("El enlace ha expirado o es inválido.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-fondo p-4">
      <Card className="w-full max-w-sm p-8">
        <h2 className="text-2xl font-bold text-principal mb-6 text-center">Nueva Contraseña</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Nueva Contraseña</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 border rounded-lg" required />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">Confirmar Contraseña</label>
            <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="w-full px-4 py-3 border rounded-lg" required />
          </div>
          <Button type="submit" variant="primary" className="w-full">Guardar Contraseña</Button>
        </form>
      </Card>
    </div>
  );
}

export default ResetPassword;